<div class="h-full flex flex-col justify-start items-center overflow-hidden space-y-4">


    <!-- Header -->
    <div
        class="flex-0 flex flex-row items-center justify-between w-full border-b border-zinc-200 dark:border-zinc-800 pb-2 pr-1">

        <div class="flex-1 flex flex-row items-center justify-start gap-x-4 sm:gap-x-6">
            <button (click)="goBack()" type="button" class="btn-fab-secondary">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5">
                    <path d="m12 19-7-7 7-7" />
                    <path d="M19 12H5" />
                </svg>
            </button>

            <div class="w-full flex flex-row items-center justify-between gap-x-2">

                <div class="">
                    <div class="group inline-flex gap-x-2 cursor-pointer">
                        <h3 class="text-md font-semibold text-primary group-hover:underline">
                            {{ creator()?.name ?? 'Loading…' }}
                        </h3>
                        <span
                            class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset bg-sky-50 dark:bg-sky-900/30 text-sky-700 ring-sky-600 ring-opacity-20">Screening
                            Result</span>
                    </div>
                    <p class="mt-0 text-xs text-secondary">Brief Title</p>
                </div>


                <scr-screening-tabs [tabs]="tabs()" [activeId]="activeTab()" ariaLabel="Creator report sections"
                    (tabSelect)="selectTab($event)" />

            </div>
        </div>

        <div class="shrink-0 flex flex-row items-center justify-end gap-x-2">


            <!-- Divider -->
            <div class="hidden h-8 border border-gray-200 dark:border-gray-700 rounded-md sm:block"></div>


            <scr-verdict-pill [verdict]="progress().verdict" size="lg" />

            @if (showGenerateReport()) {
            <button type="button" class="btn-shout btn-shout-sm btn-shout-primary shrink-0" (click)="generateReport()"
                [disabled]="generatingReport()" [attr.aria-busy]="generatingReport()">
                {{ generatingReport() ? 'Generating report…' : 'Generate Report' }}
                <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" class="size-5">
                    <path
                        d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z"
                        clip-rule="evenodd" fill-rule="evenodd" />
                </svg>
            </button>
            }


            @if (activeTab() === 'content') {

            <el-select name="content-view" [attr.value]="contentFilter()">
                <div class="inline-flex divide-x divide-white/25 rounded-md outline-hidden">
                    <div class="inline-flex items-center gap-x-1.5 rounded-l-md bg-primary px-3 py-2 text-white">
                        <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" class="-ml-0.5 size-5">
                            <path
                                d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                clip-rule="evenodd" fill-rule="evenodd" />
                        </svg>
                        <el-selectedcontent class="text-sm font-semibold">{{ contentFilter() === 'issues' ? 'With issues' : 'All content' }}</el-selectedcontent>
                    </div>
                    <button type="button" aria-label="Choose which content to show"
                        class="inline-flex items-center rounded-l-none rounded-r-md bg-primary p-2 text-white hover:bg-primary/85 focus-visible:outline-2 focus-visible:outline-primary">
                        <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" class="size-5">
                            <path
                                d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z"
                                clip-rule="evenodd" fill-rule="evenodd" />
                        </svg>
                    </button>
                </div>

                <el-options anchor="bottom end" popover
                    class="w-72 origin-top-right divide-y divide-border overflow-hidden rounded-md bg-card shadow-lg outline-1 outline-black/5 [--anchor-gap:--spacing(2)] data-leave:transition data-leave:transition-discrete data-leave:duration-100 data-leave:ease-in data-closed:data-leave:opacity-0">
                    <el-option value="all" (click)="setContentFilter('all')"
                        class="group/option block cursor-default p-4 text-sm text-foreground select-none focus:bg-primary focus:text-white focus:outline-hidden">
                        <div class="flex flex-col">
                            <div class="flex items-center justify-between gap-2">
                                <p
                                    class="m-0 font-normal group-aria-selected/option:font-semibold in-[el-selectedcontent]:font-semibold">
                                    All content</p>
                                <div class="flex items-center gap-2">
                                    <p
                                        class="m-0 rounded-full bg-muted px-2 py-0.5 text-xs font-semibold tabular-nums text-muted-foreground in-[el-selectedcontent]:hidden group-focus/option:bg-white/20 group-focus/option:text-white">
                                        {{ content().length }}</p>
                                    <span
                                        class="text-primary group-not-aria-selected/option:hidden group-focus/option:text-white in-[el-selectedcontent]:hidden">
                                        <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" class="size-5">
                                            <path
                                                d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                                clip-rule="evenodd" fill-rule="evenodd" />
                                        </svg>
                                    </span>
                                </div>
                            </div>
                            <p
                                class="m-0 mt-2 text-muted-foreground group-focus/option:text-white/80 in-[el-selectedcontent]:hidden">
                                Every post screened for this creator.</p>
                        </div>
                    </el-option>
                    <el-option value="issues" (click)="setContentFilter('issues')"
                        class="group/option block cursor-default p-4 text-sm text-foreground select-none focus:bg-primary focus:text-white focus:outline-hidden">
                        <div class="flex flex-col">
                            <div class="flex items-center justify-between gap-2">
                                <p
                                    class="m-0 font-normal group-aria-selected/option:font-semibold in-[el-selectedcontent]:font-semibold">
                                    With issues</p>
                                <div class="flex items-center gap-2">
                                    <p
                                        class="m-0 rounded-full bg-muted px-2 py-0.5 text-xs font-semibold tabular-nums text-muted-foreground in-[el-selectedcontent]:hidden group-focus/option:bg-white/20 group-focus/option:text-white">
                                        {{ issueContentCount() }}</p>
                                    <span
                                        class="text-primary group-not-aria-selected/option:hidden group-focus/option:text-white in-[el-selectedcontent]:hidden">
                                        <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" class="size-5">
                                            <path
                                                d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                                clip-rule="evenodd" fill-rule="evenodd" />
                                        </svg>
                                    </span>
                                </div>
                            </div>
                            <p
                                class="m-0 mt-2 text-muted-foreground group-focus/option:text-white/80 in-[el-selectedcontent]:hidden">
                                Only posts that failed at least one rule.</p>
                        </div>
                    </el-option>
                </el-options>
            </el-select>

            }


            <button type="button" class="btn-fab-secondary">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5">
                    <path
                        d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" />
                    <path d="M14 2v5a1 1 0 0 0 1 1h5" />
                    <path d="M12 18v-6" />
                    <path d="m9 15 3 3 3-3" />
                </svg>
            </button>


        </div>
    </div>

    <!-- Header - END -->


    <div class="h-full flex-1 flex-col items-center justify-center w-full overflow-hidden" role="tabpanel"
        [id]="'scr-panel-' + activeTab()" [attr.aria-labelledby]="'scr-tab-' + activeTab()" tabindex="0">


        @switch (activeTab()) {

        @case ('report') {
        <article
            class="rp-doc overflow-hidden rounded-xl border border-border bg-card shadow-sm flex flex-col h-full border-2 border-blue-500">
            <div class="shrink-0 w-full rp-no-print border-b border-border bg-muted/50 px-3 py-3">
                <div class="flex flex-wrap items-center justify-between sm:flex-nowrap">
                    <div class="flex min-w-0 flex-row items-center justify-start gap-x-2">
                        <div class="flex flex-col items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-5 text-accent">
                                <path
                                    d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" />
                                <path d="M14 2v5a1 1 0 0 0 1 1h5" />
                                <path d="m9 15 2 2 4-4" />
                            </svg>
                        </div>
                        <div class="flex min-w-0 flex-col">
                            <h3 class="text-sm font-semibold text-primary">Standard screening report</h3>
                            <p class="hidden sm:block mt-0.5 text-xs text-secondary">{{ results.brief()?.briefTitle }}
                            </p>
                        </div>
                    </div>
                    <div class="shrink-0 flex flex-row items-center gap-x-2">
                        <button type="button" [attr.aria-disabled]="true"
                            class="secondary-button inline-flex cursor-not-allowed items-center gap-1.5 opacity-60">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-4">
                                <path d="M12 15V3" />
                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                <path d="m7 10 5 5 5-5" />
                            </svg>
                            <span class="text-xs">Export PDF</span>
                        </button>
                    </div>
                </div>
            </div>

            <div class="flex-1 flex flex-col w-full p-4 overflow-hidden">
                <div class="flex items-center gap-5 h-full flex flex-col overflow-y-auto">

                    <div class="w-full rp-verdict flex items-center gap-5 rounded-xl border p-5"
                        [attr.data-verdict]="progress().verdict">
                        <span class="rp-vic grid size-14 shrink-0 place-items-center rounded-full text-white"
                            [attr.data-verdict]="progress().verdict" aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                stroke-linejoin="round">
                                <path d="M20 6 9 17l-5-5" />
                            </svg>
                        </span>
                        <div class="min-w-0">
                            <h2
                                class="m-0 font-heading text-3xl font-extrabold leading-none tracking-[-0.02em] text-foreground">
                                {{ progress().verdict === 'progress' ? 'Screening' : (progress().verdict | titlecase) }}
                            </h2>
                            <p class="m-0 mt-2 max-w-[70ch] text-pretty text-sm leading-relaxed text-foreground/80">
                                {{ verdictLine() }}
                            </p>
                        </div>
                    </div>

                    <dl
                        class="m-0 grid w-full shrink-0 grid-cols-2 overflow-hidden rounded-xl border border-border bg-card">
                        <div class="min-w-0 border-b border-r border-border px-5 py-4">
                            <dt class="text-xs font-bold uppercase tracking-wider text-muted-foreground">
                                Content evaluated</dt>
                            <dd [class]="hasContentTotals() ? statFigureClass : statPendingClass">
                                @if (hasContentTotals()) {
                                {{ progress().evaluated }}<small
                                    class="ml-1 font-sans text-xs font-semibold tracking-normal text-muted-foreground">of
                                    {{ progress().total }}</small>
                                } @else {
                                Pending
                                }
                            </dd>
                        </div>
                        <div class="min-w-0 border-b border-border px-5 py-4">
                            <dt class="text-xs font-bold uppercase tracking-wider text-muted-foreground">
                                Rules checked</dt>
                            <dd [class]="hasRuleTotals() ? statFigureClass : statPendingClass">
                                @if (hasRuleTotals()) {
                                {{ results.rules().length }}<small
                                    class="ml-1 font-sans text-xs font-semibold tracking-normal text-muted-foreground">per
                                    item</small>
                                } @else {
                                Pending
                                }
                            </dd>
                        </div>
                        <div class="min-w-0 border-r border-border px-5 py-4">
                            <dt class="text-xs font-bold uppercase tracking-wider text-muted-foreground">
                                {{ breachedLabel() }}</dt>
                            <dd [class]="breachedStatClass()">
                                @if (hasContentTotals()) {
                                {{ breachedCount() }}
                                } @else {
                                Pending
                                }
                            </dd>
                        </div>
                        <div class="min-w-0 px-5 py-4">
                            <dt class="text-xs font-bold uppercase tracking-wider text-muted-foreground">
                                Completion</dt>
                            <dd [class]="hasContentTotals() ? statFigureClass : statPendingClass">
                                @if (hasContentTotals()) {
                                {{ progress().completion }}%
                                } @else {
                                Pending
                                }
                            </dd>
                        </div>
                    </dl>

                    <!-- 1. Executive summary -->
                    <section class="w-full">
                        <h3 class="m-0 font-heading text-xl font-bold text-foreground">{{
                            placeholderSections[0].heading }}</h3>
                        <p class="m-0 mb-3 mt-1 text-[13px] text-muted-foreground">{{
                            placeholderSections[0].description }}</p>
                        @if (executiveSummary(); as summary) {
                        <p class="m-0 max-w-prose whitespace-pre-line text-pretty text-sm leading-relaxed text-foreground">{{
                            summary }}</p>
                        } @else {
                        <scr-report-placeholder [lineWidths]="placeholderSections[0].lineWidths"
                            [caption]="placeholderSections[0].caption" />
                        }
                    </section>

                    <!-- 2. Rule-by-rule scorecard (real) -->
                    <section class="w-full">
                        <h3 class="m-0 font-heading text-xl font-bold text-foreground">Rule-by-rule scorecard</h3>
                        <p class="m-0 mb-3 mt-1 text-[13px] text-muted-foreground">
                            All {{ results.rules().length }} rules extracted from the brief, scored across this
                            creator's content.
                        </p>

                        @if (unattributedNote(); as note) {
                        <p
                            class="mb-3 rounded-md border border-amber-500/30 bg-amber-50 p-3 text-[13px] leading-relaxed text-amber-800 dark:bg-amber-400/10 dark:text-amber-300">
                            {{ note }}
                        </p>
                        }

                        @if (scoredRules().length) {
                        <ul class="m-0 list-none overflow-hidden rounded-xl border border-border p-0">
                            @for (scored of scoredRules(); track scored.rule.id) {
                            <li class="rp-rule flex items-start gap-3 border-b border-border bg-card px-4 py-3 last:border-b-0"
                                [attr.data-outcome]="scored.outcome">
                                <span class="w-8 shrink-0 font-mono text-[11px] text-muted-foreground">{{
                                    ruleNumberLabel(scored.number) }}</span>
                                <span class="min-w-0 flex-1 text-sm leading-relaxed text-foreground">{{
                                    scored.rule.statement }}</span>
                                <span class="shrink-0 text-[11px] font-bold uppercase tracking-wide"
                                    [class]="scored.outcome === 'breached' ? 'text-red-500 dark:text-red-400' : scored.outcome === 'met' ? 'text-green-700 dark:text-green-400' : 'text-muted-foreground'">
                                    {{ outcomeLabel(scored.outcome) }}
                                </span>
                            </li>
                            }
                        </ul>
                        } @else {
                        <p
                            class="rounded-xl border border-dashed border-border p-6 text-center text-sm text-muted-foreground">
                            No rules have been extracted from this brief yet.
                        </p>
                        }
                    </section>

                    <!-- 3. Red flags (real) -->
                    <section class="w-full">
                        <h3 class="m-0 font-heading text-xl font-bold text-foreground">Red flags raised</h3>
                        <p class="m-0 mb-3 mt-1 text-[13px] text-muted-foreground">
                            {{ flags().length ? 'Every breach found, with the evidence attached.' : "Nothing in this
                            creator's content breached a rule." }}
                        </p>

                        @if (flags().length) {
                        <ul class="m-0 flex list-none flex-col gap-3 p-0">
                            @for (flag of flags(); track flag.id) {
                            <li class="rp-flag flex gap-3 rounded-xl border border-border bg-card p-4">
                                <div class="min-w-0 flex-1">
                                    <p class="m-0 text-sm font-semibold text-foreground">
                                        @if (flag.ruleIndex) {
                                        <span class="font-mono text-[11px] text-muted-foreground">{{
                                            ruleNumberLabel(flag.ruleIndex) }}</span> ·
                                        }
                                        {{ flag.statement }}
                                    </p>
                                    @if (flag.finding) {
                                    <p class="m-0 mt-2 text-[13.5px] leading-relaxed text-foreground/80">{{
                                        flag.finding }}</p>
                                    }
                                    @if (flag.quote) {
                                    <blockquote
                                        class="m-0 mt-2 border-l-2 border-brand-studio pl-3 text-sm italic text-foreground/80">
                                        “{{ flag.quote }}”</blockquote>
                                    }
                                    @if (flag.at) {
                                    <p class="m-0 mt-2 text-[11.5px] text-muted-foreground">Timestamp <b
                                            class="font-semibold text-foreground/80">{{ flag.at }}</b></p>
                                    }
                                </div>
                                <scr-severity-pill [severity]="flag.severity" />
                            </li>
                            }
                        </ul>
                        } @else if (attribution() === 'counts-only' && progress().issues > 0) {
                        <p class="rounded-xl border border-dashed border-border p-6 text-sm text-muted-foreground">
                            {{ progress().issues }} issues found across {{ progress().flaggedContent }} items.
                            We haven't yet reported which rule each one relates to.
                        </p>
                        } @else {
                        <p
                            class="flex items-center gap-2.5 rounded-xl border border-dashed border-border p-6 text-sm text-muted-foreground">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" aria-hidden="true">
                                <path
                                    d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
                                <path d="m9 12 2 2 4-4" />
                            </svg>
                            No red flags raised against this creator's content.
                        </p>
                        }
                    </section>

                    <!-- 4-6. the remaining placeholders -->
                    @for (section of placeholderSections.slice(1); track section.heading) {
                    <section class="w-full">
                        <h3 class="m-0 font-heading text-xl font-bold text-foreground">{{ section.heading }}</h3>
                        <p class="m-0 mb-3 mt-1 text-[13px] text-muted-foreground">{{ section.description }}</p>
                        <scr-report-placeholder [lineWidths]="section.lineWidths" [caption]="section.caption" />
                    </section>
                    }

                </div>
            </div>

            <div
                class="shrink-0 w-full flex flex-wrap items-center gap-2.5 border-t border-border bg-muted px-5 py-3.5 text-[12px] text-muted-foreground">
                <span>Standard report format. Switch this brief to a custom analysis to change what appears
                    here.</span>
                <span class="ml-auto">Brief <span class="font-mono">{{ briefId() }}</span></span>
            </div>
        </article>
        }

        @case ('content') {
        @if (visibleContent().length) {
        <div class="h-full overflow-hidden">
            <ul
                class="m-0 grid list-none grid-cols-1 gap-3.5 p-0 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 h-full overflow-y-auto">
                @for (item of visibleContent(); track item.id) {
                <li>
                    <scr-content-card [item]="item" [position]="$index + 1" [briefId]="briefId()!!" />
                </li>
                }
            </ul>
        </div>
        } @else if (content().length) {
        <scr-coming-soon icon="file-text" heading="No content with issues" badge=""
            body="Every screened post passed its rules. Switch back to all content to see the full set." />
        } @else {
        <scr-coming-soon icon="file-text" heading="No content screened yet"
            body="Once we evaluate this creator's posts against the brief, every item will appear here with its verdict and the rules it met." />
        }
        }

        @case ('media') {
        <scr-coming-soon icon="image" [heading]="mediaCopy.heading" [body]="mediaCopy.body" />
        }
        }

    </div>
</div>